import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, ListGroup, Badge, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHistory,
    faUser,
    faCalendarCheck,
    faInfoCircle,
    faPen
} from "@fortawesome/free-solid-svg-icons";
import { DarkModeContext } from "../../context/DarkModeContext";
import CRMModalEditarSeguimiento from "./CRMModalEditarSeguimiento";
import { getToken } from "../../utils/auth";


const CRMModalHistorial = ({ show, onHide, cliente }) => {
    const { darkMode } = useContext(DarkModeContext);
    const [historial, setHistorial] = useState([]);
    const [loading, setLoading] = useState(false);

    const [showEditar, setShowEditar] = useState(false);
    const [registroEditar, setRegistroEditar] = useState(null);

    useEffect(() => {
        if (show) {
            fetchHistorial();
        }
    }, [show, cliente?.cuit, cliente?.telefono]);

    const fetchHistorial = async () => {
        setLoading(true);
        const token = getToken();

        try {
            const response = await fetch(process.env.REACT_APP_API_CRM_OBTENER_HISTORIAL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: token,
                    Cuit: cliente?.cuit || null,
                    Telefono: cliente?.telefono || null
                }),
            });

            if (response.ok) {
                setHistorial(await response.json());
            } else {
                setHistorial([]);
            }
        } catch (error) {
            console.error(error);
            setHistorial([]);
        } finally {
            setLoading(false);
        }
    };

    const formatearNombre = (nombre) => {
        if (!nombre) return "Cliente";
        return nombre.replace("[NUEVO]", "").replace("Prospecto:", "").split("|")[0].trim();
    };

    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                centered
                size="lg"
                className={darkMode ? "text-dark" : ""}
                backdrop="static"
            >
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title>
                        <FontAwesomeIcon icon={faHistory} className="me-2" />
                        Línea de Tiempo: {formatearNombre(cliente?.nombreCliente)}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: "500px", overflowY: "auto" }}>
                    <div className="mb-3 p-2 rounded bg-light border">
                        <small className="d-block text-muted">
                            <strong>CUIT:</strong> {cliente?.cuit || ""}
                        </small>
                        <small className="d-block text-muted">
                            <strong>TEL:</strong> {cliente?.telefono || ""}
                        </small>
                    </div>

                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" />
                            <p className="mt-2 fw-bold">Consultando historial...</p>
                        </div>
                    ) : historial.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                            <FontAwesomeIcon icon={faInfoCircle} size="3x" className="mb-3 opacity-25" />
                            <p>No se encontraron gestiones anteriores.</p>
                        </div>
                    ) : (
                        <ListGroup variant="flush">
                            {historial.map((item) => (
                                <ListGroup.Item
                                    key={item.id}
                                    className={`mb-3 border rounded shadow-sm border-start border-4 ${item.alertaActiva ? "border-success" : "border-secondary"
                                        }`}
                                >
                                    <div className="d-flex justify-content-between">
                                        <Badge bg={item.alertaActiva ? "success" : "secondary"}>
                                            {item.reglaAplicada?.aliasVista || "Seguimiento"}
                                        </Badge>

                                        <div className="text-end small fw-bold">
                                            {new Date(item.fechaGestion).toLocaleString("es-ES")}
                                        </div>
                                    </div>

                                    <div className="p-2 my-2 bg-light rounded">
                                        {item.observacion || "Sin observaciones."}
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center border-top pt-2">
                                        <small className="text-muted">
                                            <FontAwesomeIcon icon={faUser} className="me-1" />
                                            Asesor ID: {item.idUsuarioGestor}
                                        </small>

                                        {item.fechaProximoContacto && (
                                            <Badge bg="light" className="border border-primary text-primary">
                                                <FontAwesomeIcon icon={faCalendarCheck} className="me-1" />
                                                Recontacto:{" "}
                                                {new Date(item.fechaProximoContacto).toLocaleDateString()}
                                            </Badge>
                                        )}
                                    </div>

                                    <div className="mt-2 d-flex gap-3">
                                        <small className="text-muted"><strong>CUIT:</strong> {item.cuit || ""}</small>
                                        <small className="text-muted"><strong>TEL:</strong> {item.telefono || ""}</small>
                                    </div>

                                    <div className="text-end mt-2">
                                        <Button
                                            size="sm"
                                            variant="outline-primary"
                                            onClick={() => {
                                                setRegistroEditar(item);
                                                setShowEditar(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faPen} className="me-1" />
                                            Editar
                                        </Button>
                                    </div>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Modal.Body>

                <Modal.Footer className="bg-light">
                    <Button variant="secondary" onClick={onHide}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL EDITAR */}
            <CRMModalEditarSeguimiento
                show={showEditar}
                onHide={() => setShowEditar(false)}
                registro={registroEditar}
                onGuardado={fetchHistorial}
            />
        </>
    );
};

export default CRMModalHistorial;
